import { generateUniqueId } from '@acre/utils'

import { getProviderName } from '../../../../pages/GeneralInsurance/GeneralInsurance.helpers'

export const getPredictedRevenueFromGI = (giProducts: CreateGeneralInsuranceProductDetails[]) => {
  const selectedGIProducts = giProducts.filter(
    (product) => product.commission && (product.status === 'SELECTED' || product.status === 'APPLICATION_IN_PROGRESS'),
  )

  return selectedGIProducts.map((product) => {
    const providerName = getProviderName(product?.provider || '')

    return {
      id: generateUniqueId(),
      value: product.commission,
      fee_type: 'giProcFee',
      payer: providerName !== 'Unknown provider' ? providerName : 'insurer',
      commission: null,
      frequency: null,
      commission_period: null,
    }
  })
}
